export const calculateAllocationExpenses = (incomeTotal, cappedRate) => {
  return Math.round((incomeTotal * cappedRate) / 100);
};
